import { default as indextDqxDlA3cnMeta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/auth/index.vue?macro=true";
import { default as indexJ2fNojRo3SMeta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/auth/social/[organisation]/[provider]/index.vue?macro=true";
import { default as indexF7ZX2d9ozRMeta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/index/index.vue?macro=true";
import { default as orderBK1tKFXJRZMeta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/index/order.vue?macro=true";
import { default as orderSuccessAZ2dbd2q0RMeta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/index/orderSuccess.vue?macro=true";
import { default as indexJZ0mKoEPrHMeta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/index.vue?macro=true";
import { default as attributeBaseDataXKQnyLHw3DMeta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/configurator/attributes/[id]/attributeBaseData.vue?macro=true";
import { default as _91id_931myyTvtBRNMeta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/configurator/attributes/[id].vue?macro=true";
import { default as componentBaseData7vuz6kDYIoMeta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/configurator/components/[id]/componentBaseData.vue?macro=true";
import { default as _91id_93wPRXLbVyvbMeta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/configurator/components/[id].vue?macro=true";
import { default as index9ZP2YnibsQMeta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/configurator/components/index.vue?macro=true";
import { default as variantBaseDatafr9wicBu6UMeta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/configurator/variants/[id]/variantBaseData.vue?macro=true";
import { default as _91id_935m4tnRouP5Meta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/configurator/variants/[id].vue?macro=true";
import { default as indexCmeM1J1NvqMeta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/configurator/variants/index.vue?macro=true";
import { default as configuratorDhWF9WnUFHMeta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/configurator.vue?macro=true";
import { default as indexaftmbQ7OHMMeta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/index.vue?macro=true";
import { default as orderBaseDataXge52F0TKaMeta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/orders/[id]/orderBaseData.vue?macro=true";
import { default as _91id_93QuOXFqLQ26Meta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/orders/[id].vue?macro=true";
import { default as indexTaOvfV7xYwMeta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/orders/index.vue?macro=true";
import { default as languageXM6nFpdxAlMeta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/settings/language.vue?macro=true";
import { default as _91id_93NRWKuiuQwFMeta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/settings/loginProviders/[id].vue?macro=true";
import { default as index67ZAn8eMOpMeta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/settings/loginProviders/index.vue?macro=true";
import { default as rolessLV4QPlfk1Meta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/settings/roles.vue?macro=true";
import { default as settingsXpjXbbxmiZMeta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/settings.vue?macro=true";
import { default as userActivitiesZnfuqNmCytMeta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/users/[id]/userActivities.vue?macro=true";
import { default as userBaseDataljHgaAoSSWMeta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/users/[id]/userBaseData.vue?macro=true";
import { default as userCommunications22jFIEZK04Meta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/users/[id]/userCommunications.vue?macro=true";
import { default as _91id_93uoa3AwlrzzMeta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/users/[id].vue?macro=true";
import { default as indexRSyuwX4Qa4Meta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/users/index.vue?macro=true";
import { default as usersZrWPe4j8uLMeta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/users.vue?macro=true";
import { default as service3wQe8GexOBMeta } from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service.vue?macro=true";
export default [
  {
    name: indextDqxDlA3cnMeta?.name ?? "auth",
    path: indextDqxDlA3cnMeta?.path ?? "/auth",
    meta: indextDqxDlA3cnMeta || {},
    alias: indextDqxDlA3cnMeta?.alias || [],
    redirect: indextDqxDlA3cnMeta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/auth/index.vue").then(m => m.default || m)
  },
  {
    name: indexJ2fNojRo3SMeta?.name ?? "auth-social-organisation-provider",
    path: indexJ2fNojRo3SMeta?.path ?? "/auth/social/:organisation()/:provider()",
    meta: indexJ2fNojRo3SMeta || {},
    alias: indexJ2fNojRo3SMeta?.alias || [],
    redirect: indexJ2fNojRo3SMeta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/auth/social/[organisation]/[provider]/index.vue").then(m => m.default || m)
  },
  {
    path: indexJZ0mKoEPrHMeta?.path ?? "/",
    children: [
  {
    name: indexF7ZX2d9ozRMeta?.name ?? "index",
    path: indexF7ZX2d9ozRMeta?.path ?? "",
    meta: indexF7ZX2d9ozRMeta || {},
    alias: indexF7ZX2d9ozRMeta?.alias || [],
    redirect: indexF7ZX2d9ozRMeta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/index/index.vue").then(m => m.default || m)
  },
  {
    name: orderBK1tKFXJRZMeta?.name ?? "index-order",
    path: orderBK1tKFXJRZMeta?.path ?? "order",
    meta: orderBK1tKFXJRZMeta || {},
    alias: orderBK1tKFXJRZMeta?.alias || [],
    redirect: orderBK1tKFXJRZMeta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/index/order.vue").then(m => m.default || m)
  },
  {
    name: orderSuccessAZ2dbd2q0RMeta?.name ?? "index-orderSuccess",
    path: orderSuccessAZ2dbd2q0RMeta?.path ?? "orderSuccess",
    meta: orderSuccessAZ2dbd2q0RMeta || {},
    alias: orderSuccessAZ2dbd2q0RMeta?.alias || [],
    redirect: orderSuccessAZ2dbd2q0RMeta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/index/orderSuccess.vue").then(m => m.default || m)
  }
],
    name: indexJZ0mKoEPrHMeta?.name ?? undefined,
    meta: indexJZ0mKoEPrHMeta || {},
    alias: indexJZ0mKoEPrHMeta?.alias || [],
    redirect: indexJZ0mKoEPrHMeta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/index.vue").then(m => m.default || m)
  },
  {
    path: service3wQe8GexOBMeta?.path ?? "/service",
    children: [
  {
    name: configuratorDhWF9WnUFHMeta?.name ?? "service-configurator",
    path: configuratorDhWF9WnUFHMeta?.path ?? "configurator",
    children: [
  {
    name: _91id_931myyTvtBRNMeta?.name ?? "service-configurator-attributes-id",
    path: _91id_931myyTvtBRNMeta?.path ?? "attributes/:id()",
    children: [
  {
    name: attributeBaseDataXKQnyLHw3DMeta?.name ?? "service-configurator-attributes-id-attributeBaseData",
    path: attributeBaseDataXKQnyLHw3DMeta?.path ?? "attributeBaseData",
    meta: attributeBaseDataXKQnyLHw3DMeta || {},
    alias: attributeBaseDataXKQnyLHw3DMeta?.alias || [],
    redirect: attributeBaseDataXKQnyLHw3DMeta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/configurator/attributes/[id]/attributeBaseData.vue").then(m => m.default || m)
  }
],
    meta: _91id_931myyTvtBRNMeta || {},
    alias: _91id_931myyTvtBRNMeta?.alias || [],
    redirect: _91id_931myyTvtBRNMeta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/configurator/attributes/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93wPRXLbVyvbMeta?.name ?? "service-configurator-components-id",
    path: _91id_93wPRXLbVyvbMeta?.path ?? "components/:id()",
    children: [
  {
    name: componentBaseData7vuz6kDYIoMeta?.name ?? "service-configurator-components-id-componentBaseData",
    path: componentBaseData7vuz6kDYIoMeta?.path ?? "componentBaseData",
    meta: componentBaseData7vuz6kDYIoMeta || {},
    alias: componentBaseData7vuz6kDYIoMeta?.alias || [],
    redirect: componentBaseData7vuz6kDYIoMeta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/configurator/components/[id]/componentBaseData.vue").then(m => m.default || m)
  }
],
    meta: _91id_93wPRXLbVyvbMeta || {},
    alias: _91id_93wPRXLbVyvbMeta?.alias || [],
    redirect: _91id_93wPRXLbVyvbMeta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/configurator/components/[id].vue").then(m => m.default || m)
  },
  {
    name: index9ZP2YnibsQMeta?.name ?? "service-configurator-components",
    path: index9ZP2YnibsQMeta?.path ?? "components",
    meta: index9ZP2YnibsQMeta || {},
    alias: index9ZP2YnibsQMeta?.alias || [],
    redirect: index9ZP2YnibsQMeta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/configurator/components/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_935m4tnRouP5Meta?.name ?? "service-configurator-variants-id",
    path: _91id_935m4tnRouP5Meta?.path ?? "variants/:id()",
    children: [
  {
    name: variantBaseDatafr9wicBu6UMeta?.name ?? "service-configurator-variants-id-variantBaseData",
    path: variantBaseDatafr9wicBu6UMeta?.path ?? "variantBaseData",
    meta: variantBaseDatafr9wicBu6UMeta || {},
    alias: variantBaseDatafr9wicBu6UMeta?.alias || [],
    redirect: variantBaseDatafr9wicBu6UMeta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/configurator/variants/[id]/variantBaseData.vue").then(m => m.default || m)
  }
],
    meta: _91id_935m4tnRouP5Meta || {},
    alias: _91id_935m4tnRouP5Meta?.alias || [],
    redirect: _91id_935m4tnRouP5Meta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/configurator/variants/[id].vue").then(m => m.default || m)
  },
  {
    name: indexCmeM1J1NvqMeta?.name ?? "service-configurator-variants",
    path: indexCmeM1J1NvqMeta?.path ?? "variants",
    meta: indexCmeM1J1NvqMeta || {},
    alias: indexCmeM1J1NvqMeta?.alias || [],
    redirect: indexCmeM1J1NvqMeta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/configurator/variants/index.vue").then(m => m.default || m)
  }
],
    meta: configuratorDhWF9WnUFHMeta || {},
    alias: configuratorDhWF9WnUFHMeta?.alias || [],
    redirect: configuratorDhWF9WnUFHMeta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/configurator.vue").then(m => m.default || m)
  },
  {
    name: indexaftmbQ7OHMMeta?.name ?? "service",
    path: indexaftmbQ7OHMMeta?.path ?? "",
    meta: indexaftmbQ7OHMMeta || {},
    alias: indexaftmbQ7OHMMeta?.alias || [],
    redirect: indexaftmbQ7OHMMeta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93QuOXFqLQ26Meta?.name ?? "service-orders-id",
    path: _91id_93QuOXFqLQ26Meta?.path ?? "orders/:id()",
    children: [
  {
    name: orderBaseDataXge52F0TKaMeta?.name ?? "service-orders-id-orderBaseData",
    path: orderBaseDataXge52F0TKaMeta?.path ?? "orderBaseData",
    meta: orderBaseDataXge52F0TKaMeta || {},
    alias: orderBaseDataXge52F0TKaMeta?.alias || [],
    redirect: orderBaseDataXge52F0TKaMeta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/orders/[id]/orderBaseData.vue").then(m => m.default || m)
  }
],
    meta: _91id_93QuOXFqLQ26Meta || {},
    alias: _91id_93QuOXFqLQ26Meta?.alias || [],
    redirect: _91id_93QuOXFqLQ26Meta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/orders/[id].vue").then(m => m.default || m)
  },
  {
    name: indexTaOvfV7xYwMeta?.name ?? "service-orders",
    path: indexTaOvfV7xYwMeta?.path ?? "orders",
    meta: indexTaOvfV7xYwMeta || {},
    alias: indexTaOvfV7xYwMeta?.alias || [],
    redirect: indexTaOvfV7xYwMeta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/orders/index.vue").then(m => m.default || m)
  },
  {
    name: settingsXpjXbbxmiZMeta?.name ?? "service-settings",
    path: settingsXpjXbbxmiZMeta?.path ?? "settings",
    children: [
  {
    name: languageXM6nFpdxAlMeta?.name ?? "service-settings-language",
    path: languageXM6nFpdxAlMeta?.path ?? "language",
    meta: languageXM6nFpdxAlMeta || {},
    alias: languageXM6nFpdxAlMeta?.alias || [],
    redirect: languageXM6nFpdxAlMeta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/settings/language.vue").then(m => m.default || m)
  },
  {
    name: _91id_93NRWKuiuQwFMeta?.name ?? "service-settings-loginProviders-id",
    path: _91id_93NRWKuiuQwFMeta?.path ?? "loginProviders/:id()",
    meta: _91id_93NRWKuiuQwFMeta || {},
    alias: _91id_93NRWKuiuQwFMeta?.alias || [],
    redirect: _91id_93NRWKuiuQwFMeta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/settings/loginProviders/[id].vue").then(m => m.default || m)
  },
  {
    name: index67ZAn8eMOpMeta?.name ?? "service-settings-loginProviders",
    path: index67ZAn8eMOpMeta?.path ?? "loginProviders",
    meta: index67ZAn8eMOpMeta || {},
    alias: index67ZAn8eMOpMeta?.alias || [],
    redirect: index67ZAn8eMOpMeta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/settings/loginProviders/index.vue").then(m => m.default || m)
  },
  {
    name: rolessLV4QPlfk1Meta?.name ?? "service-settings-roles",
    path: rolessLV4QPlfk1Meta?.path ?? "roles",
    meta: rolessLV4QPlfk1Meta || {},
    alias: rolessLV4QPlfk1Meta?.alias || [],
    redirect: rolessLV4QPlfk1Meta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/settings/roles.vue").then(m => m.default || m)
  }
],
    meta: settingsXpjXbbxmiZMeta || {},
    alias: settingsXpjXbbxmiZMeta?.alias || [],
    redirect: settingsXpjXbbxmiZMeta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/settings.vue").then(m => m.default || m)
  },
  {
    path: usersZrWPe4j8uLMeta?.path ?? "users",
    children: [
  {
    name: _91id_93uoa3AwlrzzMeta?.name ?? "service-users-id",
    path: _91id_93uoa3AwlrzzMeta?.path ?? ":id()",
    children: [
  {
    name: userActivitiesZnfuqNmCytMeta?.name ?? "service-users-id-userActivities",
    path: userActivitiesZnfuqNmCytMeta?.path ?? "userActivities",
    meta: userActivitiesZnfuqNmCytMeta || {},
    alias: userActivitiesZnfuqNmCytMeta?.alias || [],
    redirect: userActivitiesZnfuqNmCytMeta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/users/[id]/userActivities.vue").then(m => m.default || m)
  },
  {
    name: userBaseDataljHgaAoSSWMeta?.name ?? "service-users-id-userBaseData",
    path: userBaseDataljHgaAoSSWMeta?.path ?? "userBaseData",
    meta: userBaseDataljHgaAoSSWMeta || {},
    alias: userBaseDataljHgaAoSSWMeta?.alias || [],
    redirect: userBaseDataljHgaAoSSWMeta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/users/[id]/userBaseData.vue").then(m => m.default || m)
  },
  {
    name: userCommunications22jFIEZK04Meta?.name ?? "service-users-id-userCommunications",
    path: userCommunications22jFIEZK04Meta?.path ?? "userCommunications",
    meta: userCommunications22jFIEZK04Meta || {},
    alias: userCommunications22jFIEZK04Meta?.alias || [],
    redirect: userCommunications22jFIEZK04Meta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/users/[id]/userCommunications.vue").then(m => m.default || m)
  }
],
    meta: _91id_93uoa3AwlrzzMeta || {},
    alias: _91id_93uoa3AwlrzzMeta?.alias || [],
    redirect: _91id_93uoa3AwlrzzMeta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/users/[id].vue").then(m => m.default || m)
  },
  {
    name: indexRSyuwX4Qa4Meta?.name ?? "service-users",
    path: indexRSyuwX4Qa4Meta?.path ?? "",
    meta: indexRSyuwX4Qa4Meta || {},
    alias: indexRSyuwX4Qa4Meta?.alias || [],
    redirect: indexRSyuwX4Qa4Meta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/users/index.vue").then(m => m.default || m)
  }
],
    name: usersZrWPe4j8uLMeta?.name ?? undefined,
    meta: usersZrWPe4j8uLMeta || {},
    alias: usersZrWPe4j8uLMeta?.alias || [],
    redirect: usersZrWPe4j8uLMeta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service/users.vue").then(m => m.default || m)
  }
],
    name: service3wQe8GexOBMeta?.name ?? undefined,
    meta: service3wQe8GexOBMeta || {},
    alias: service3wQe8GexOBMeta?.alias || [],
    redirect: service3wQe8GexOBMeta?.redirect || undefined,
    component: () => import("/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/pages/service.vue").then(m => m.default || m)
  }
]